import styled from '@emotion/styled';

import { Button } from '../../../primitives';

type ExitConfirmBodyProps = {
  title: string;
  contents: string | JSX.Element;
  cancelExit: () => void;
  confirmExit: () => void;
};
export default function ExitConfirmBody({ title, contents, cancelExit, confirmExit }: ExitConfirmBodyProps) {
  return (
    <SModalWrapper>
      <SModalBody>
        <h3 className="title">{title}</h3>
        <div className="contents">{contents}</div>
      </SModalBody>
      <SModalFooter>
        {/* 취소는 중립(outline), 나가기만 브랜드색 — 둘 다 solid면 주액션이 구분되지 않는다 */}
        <SCancelButton variant="outline" colorScheme="neutral" onClick={cancelExit}>
          취소
        </SCancelButton>
        <SExitButton onClick={confirmExit}>나가기</SExitButton>
      </SModalFooter>
    </SModalWrapper>
  );
}

const SModalWrapper = styled.section`
  padding: 20px 24px 30px;
`;

const SModalBody = styled.div`
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;

  .title {
    ${({ theme }) => theme.font.head5_sb};
    color: ${({ theme }) => theme.color.text.default};
  }

  .contents {
    ${({ theme }) => theme.font.body2_r};
    color: ${({ theme }) => theme.color.text.TXT_2};
  }
`;

const SModalFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

const SCancelButton = styled(Button)`
  height: 50px;
  width: 120px;
`;

const SExitButton = styled(Button)`
  height: 50px;
  width: 190px;
`;
